exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.lightbox {\n  opacity: 0;\n  transition: opacity 0.25s ease;\n}\n.lightbox-open {\n  opacity: 1;\n}\n", ""]);

// exports
